import { module }from 'stereomodularjs';
import { html } from '../utils/environment'
import { createApp } from "vue/dist/vue.esm-bundler.js"
import BourseSearch from '../components/BourseSearch.vue'

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        let self = this;

        let findBackground = this.el.dataset.background;

        const app = createApp({
            template: '<BourseSearch background="'+findBackground+'" />',
            components: {
                BourseSearch
            },
            data() {
                return {
                }
            },
            mounted() {
            },
        })
        app.mount(self.el)
    }
}